import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PROJECT } from "@/app/capabilities/permissions";
import { sessionVerificationQueryOptions } from "@/app/user-verification/api/get-session-verification";
import { UserVerificationSkeleton } from "@/app/user-verification/components";
import { UserVerification } from "@/app/user-verification/list";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/settings/user-verification"
)({
  component: () => (
    <Suspense fallback={<UserVerificationSkeleton />}>
      <UserVerification />
    </Suspense>
  ),
  beforeLoad: async (ctx) => {
    await requireProjectPermission(ctx, PROJECT.securitySettings.read);
    ctx.context.queryClient.prefetchQuery(
      sessionVerificationQueryOptions({ binding: "project", scope: ctx.params })
    );
  },
  loader: () => ({
    crumb: "User Verification",
  }),
});
